import AdvocateVaishnaviSinghDetails from '../../components/about/advocates-details/VaishnaviSingh';
import Footer from '../../components/common/footer';
import Layout from '../../components/common/layout';
import NavigationMenu from '../../components/common/navigationMenu';
import PageHeader from '../../components/common/pageHeader';
import React from 'react';

const AdvocateVaishnaviSinghDetailsPage = () => {
  return (
    <Layout pageTitle='Avadhani & Associates | Kenvar Vaishnavi Singh'>
      <NavigationMenu active='about' />
      <PageHeader
        title='Kenvar Vaishnavi Singh'
        subMenu='Advocates'
        backLink='/about#team-section'
      />
      <AdvocateVaishnaviSinghDetails />
      <Footer />
    </Layout>
  );
};

export default AdvocateVaishnaviSinghDetailsPage;
